import { createElement, memo, useEffect } from '@max/max';
import Image from '@hfe/max-image';
import { MORE_MV } from '../../utils/constant';
const MyComponent = (props) => {
    var _a, _b, _c, _d;
    const { showMoreImage, mvReport, menuId, moreImageStyle } = props;
    useEffect(() => {
        mvReport && mvReport(MORE_MV, {
            valLab: {
                instance_id: menuId
            }
        });
    }, []);
    // const moreStyle = {
    //   width: `${moreImageStyle?.width ?? 290}rpx`,
    //   height: `${moreImageStyle?.height ?? 65}rpx`,
    //   marginTop: `${moreImageStyle?.marginTop ?? 12}rpx`,
    //   marginBottom: `${moreImageStyle?.marginBottom ?? 18}rpx`
    // }
    const moreStyle = {
        width: `${(_a = moreImageStyle === null || moreImageStyle === void 0 ? void 0 : moreImageStyle.width) !== null && _a !== void 0 ? _a : 172}rpx`,
        height: `${(_b = moreImageStyle === null || moreImageStyle === void 0 ? void 0 : moreImageStyle.height) !== null && _b !== void 0 ? _b : 48}rpx`,
        marginTop: `${(_c = moreImageStyle === null || moreImageStyle === void 0 ? void 0 : moreImageStyle.marginTop) !== null && _c !== void 0 ? _c : 12}rpx`,
        marginBottom: `${(_d = moreImageStyle === null || moreImageStyle === void 0 ? void 0 : moreImageStyle.marginBottom) !== null && _d !== void 0 ? _d : 18}rpx`
    };
    return <Image style={Object.assign({}, moreStyle)} resizeMode='contain' source={{
        uri: showMoreImage
    }}/>;
};
export default memo(MyComponent);
